import Svg, { G, Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgTabIconData = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}><G clipPath="url(#a)"><Path fill="currentColor" d="M21.718-.002a20.022 20.022 0 0 1 16.83 27.438l-16.83-8.538Zm-3.432 19.7v-19.7a20.04 20.04 0 0 0-5.819 38.516Zm2.754 2.713-5.295 17.125a19.9 19.9 0 0 0 21.24-9.038Z" /></G></Svg>;
const Memo = memo(SvgTabIconData);
export default Memo;